<div class="navigation-wrapper">
  <div class="navigation-header" [style]="'background-color: ' + logoBgColor">
    <a class="logo" *ngIf="this.rwdService.navPanelOpened">
      <img [src]="logo ?? 'assets/fliko.svg'" />
    </a>
    <button mat-button class="collapse-button" (click)="this.rwdService.toggleNavPanel()">
      <mat-icon [class.primary]="logoBgColor != 'unset'">
        {{ this.rwdService.navPanelOpened ? 'arrow_back_ios' : 'arrow_forward_ios' }}
      </mat-icon>
    </button>
  </div>

  <div class="menu">
    <div class="section">
      <mat-nav-list>
        <span class="section-title menu-section-title">{{ 'navigation.menu' | loc }}</span>
        <app-navigation-entry
          *ngFor="let nav of contextType == CT.COMPANY ? companyNav : estateNav"
          [vm]="nav"
          [isSelected]="isSelected(nav)"
          [collapsed]="!this.rwdService.navPanelOpened"
        ></app-navigation-entry>
      </mat-nav-list>
    </div>

    <div class="section" *ngIf="contextType == CT.ESTATE">
      <mat-nav-list>
        <span class="section-title account-section-title">{{ 'navigation.user' | loc }}</span>
        <app-navigation-entry
          *ngFor="let eNav of userNav"
          [vm]="eNav"
          [isSelected]="isSelected(eNav)"
          [collapsed]="!this.rwdService.navPanelOpened"
        ></app-navigation-entry>
      </mat-nav-list>
    </div>
  </div>
</div>
